// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-3H3Ew","text":"text-1rLUF"};